<template>
	<div>
		<tab name="16">{{id}} <span v-if="sessionData">{{sessionData.title}}</span></tab>
		<div class="page-list-box" v-loading="dataLoading">

			<el-card class="box-card" header="选择需要更新的信息">
				<table class="info-table" style="width:100%">
					<tr>
						<th>选择</th>
						<th width="200">字段</th>
						<th>值</th>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal1" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">艺人阵容</td>
						<td class="right">
							<el-select v-model="formData.performers" filterable remote multiple placeholder="请选择艺人"
								:remote-method="searchArtist" :loading="userLoading" size="medium" value-key="id"
								style="width: 300px;">
								<el-option v-for="a in artistList" :key="a.id" :label="a.name" :value="a">
								</el-option>
							</el-select>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal2" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">嘉宾阵容</td>
						<td class="right">
							<el-select v-model="formData.guests" filterable remote multiple placeholder="请选择艺人"
								:remote-method="searchGuests" :loading="userLoading" size="medium" value-key="id"
								style="width: 300px;">
								<el-option v-for="a in guestsList" :key="a.id" :label="a.name" :value="a">
								</el-option>
							</el-select>
							<small class="ML20"><span
									class="color-danger">（非必填，支持为空，如果为空以后勾选了批量更新该项，视为批量清除嘉宾阵容）</span></small>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal3" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">阵容性质</td>
						<td class="right">
							<el-radio-group v-model="formData.lineupNature">
								<el-radio :label="1">单人专场</el-radio>
								<el-radio :label="2">多人拼盘</el-radio>
							</el-radio-group>
							<small class="ML20"><span
									class="color-danger">（对于除了主演艺人外只有嘉宾或暖场艺人的演出，应该也视为单人专场）</span></small>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal4" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">B类售票权限</td>
						<td class="right">
							<el-checkbox v-model="formData.isEditStore" :true-label="1"
								:false-label="0">允许B类用户在演出通过审核后修改本场次票品库存</el-checkbox>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal5" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">场次账号限购</td>
						<td class="right">
							<el-input v-model="formData.accountLimitBuyNum" style="width: 150px;"></el-input>
							<small class="ML20"><span
									class="color-danger">（同一场次内限制最多允许购买的票数，不限票品总类，包括免费票，填0视为不限购）</span></small>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal8" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">票品形态</td>
						<td class="right">
							<el-form v-if="formData" :model="formData" ref="formData" label-position="top">
								<ticket-type v-if="formData" :formData.sync="formData"
									:channelName.sync="channelName"></ticket-type>
							</el-form>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal6" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">票品绑定观演人</td>
						<td class="right">
							<!-- <el-radio-group v-model="formData.realName" size="medium">
							    <el-radio :label="1">开启 <small class="color-warning">每个观演人需要绑定实名证件（身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证、护照、外国人永久居留身份证、港澳台居民居住证），即一证一票</small></el-radio>
							    <el-radio :label="0">关闭</el-radio>
							</el-radio-group> -->
							<!-- <el-card  style="width: 90%;"> -->
							<div class="MT10 color-blue">
								证件绑定时机：
							</div>
							<el-radio-group v-model="formData.buyType" size="medium" class="MT10">
								<el-radio :label="0" :disabled="formData.ticketType == 5">无须绑定</el-radio>
								<el-radio :label="2">购票时要求绑定</el-radio>
								<el-radio :label="3"
									:disabled="formData.ticketType == 2 || formData.ticketType == 4">先购票后再绑定</el-radio>
							</el-radio-group>
							<div class="MT20 color-blue">
								证件类型限制：
							</div>
							<el-checkbox-group v-model="formData.commonPerformerDocumentType" size="medium"
								class="MT10">
								<el-checkbox label="1">身份证</el-checkbox>
								<el-checkbox label="2">港澳居民来往内地通行证</el-checkbox>
								<el-checkbox label="3">台湾居民来往大陆通行证</el-checkbox>
								<el-checkbox label="4">护照</el-checkbox>
								<el-checkbox label="5">外国人永久居留身份证</el-checkbox>
								<el-checkbox label="6">港澳台居民居住证</el-checkbox>
							</el-checkbox-group>
							<!-- </el-card> -->
						</td>
					</tr>

					<tr>
						<td><el-checkbox v-model="chooseVal7" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">下单人实名认证</td>
						<td class="right">
							<el-radio-group v-model="formData.realNameValidType" size="medium">
								<el-radio :label="1">证件二要素认证</el-radio>
								<el-radio :label="2">身份证人脸认证</el-radio>
								<el-radio :label="0">无须认证</el-radio>
							</el-radio-group>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal9" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">强制售罄</td>
						<td class="right">
							<!-- <el-checkbox v-model="formData.isSoldOut" :true-label="1"
								:false-label="0">开启强制售罄，开启后即使有剩余库存，也禁止用户下单、候补订单也会停止匹配</el-checkbox> -->

							<el-radio-group v-model="formData.isSoldOut" size="medium" class="MT10">
								<el-radio :label="1">开启强制售罄，开启后即使有剩余库存，也禁止用户下单、候补订单也会停止匹配</el-radio>
								<el-radio :label="0">关闭强制售罄</el-radio>
							</el-radio-group>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal10" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">是否展示销售时间：</td>
						<td class="right">
							<el-radio-group v-model="formData.isHideStartDate" size="medium">
								<el-radio :label="0">是</el-radio>
								<el-radio :label="1">否</el-radio>
							</el-radio-group>							
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal14" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">票品销售时间：</td>
						<td class="right">
							<el-date-picker v-model="startTime" type="datetime"
								placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss"
								size="medium"></el-date-picker>
							<span class="ML10 MR10">至</span>
							<el-date-picker v-model="endTime" type="datetime"
								placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
								size="medium"></el-date-picker>
							<el-checkbox v-model="formData.isAsyncAlterConsignTime" :true-label="1"
									:false-label="0" class="ML20">勾选后同步修改候补、托售结束时间</el-checkbox>
						</td>
						
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal11" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">场次预售抢票热度</td>
						<td class="right">
							<el-slider v-model="hotLevel" :step="1" :max="3"
								:format-tooltip="formatTooltip"></el-slider>
							<div>
								<!-- 热度等级{{item.setHotLevel}}: -->
								<span v-if="hotLevel == 0">大于1分钟抢光</span>
								<span v-else-if="hotLevel == 1">30秒到1分钟内抢光</span>
								<span v-else-if="hotLevel == 2">5秒到30秒抢光</span>
								<span v-else-if="hotLevel == 3">5秒内抢光</span>
							</div>
							<small class="color-danger">
								注意：系统会自动计算预估抢票力度等级，但等级仍然可以人为调整，如果人为调整了预估抢票力度，系统会以人为设置的结果为准。
							</small>
						</td>
					</tr>
					<template v-if="sessionData && sessionData.sellMode == 3">
						<tr>
							<td><el-checkbox v-model="chooseVal12" :true-label="1" :false-label="0"></el-checkbox></td>
							<td width="200">场次座位号展示逻辑</td>
							<td class="right">
								<el-radio-group v-model="showSeat" size="medium">
									<el-radio :label="1">立刻展示</el-radio>
									<el-radio :label="2">指定时间展示</el-radio>
								</el-radio-group>
								<span v-if="showSeat == 2">
									<el-date-picker v-model="formData.seatShowTime" type="datetime" placeholder="指定时间"
										value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
										default-time="20:30:00" size="medium"
										style="width:50%; margin-left: 50px;"></el-date-picker>
								</span>
							</td>
						</tr>
					</template>
					<tr>
						<td><el-checkbox v-model="chooseVal13" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">票品名称批量修改</td>
						<td class="right">
							<p>票品名称前面,批量增加：</p>
							<el-radio-group v-model="formData.updateTicketPriceNameType" size="medium" class="MT10">
								<el-radio :label="1">场次日期</el-radio>
								<el-radio :label="2">场次名称</el-radio>
							</el-radio-group>
						</td>
					</tr>
					<tr>
						<td><el-checkbox v-model="chooseVal15" :true-label="1" :false-label="0"></el-checkbox></td>
						<td width="200">场次名称批量修改</td>
						<td class="right">
							<p>将按照场次日期批量修改, 例如 2026-05-05 周二 20:00</p>							
						</td>
					</tr>
				</table>
			</el-card>
		</div>
		<el-card class="box-card" header="选择要更新的场次">
			<div v-if="sessionData && sessionData.sessions.length > 0 ">
				<el-checkbox-group v-model="formData.sessionIds" size="medium">
					<template v-for="(v,i) in sessionData.sessions">
						<el-checkbox :label="v.id" :key="i" :value="v.id">{{v.name}}</el-checkbox>
					</template>
				</el-checkbox-group>
			</div>
		</el-card>
		<div class="page-btns-box MT20">
			<el-button @click="goBack">返回</el-button>
			<el-button type="primary" @click="batchCancel()" :loading="dataLoading">批量更新</el-button>
		</div>
	</div>
</template>

<script>
	import Tab from '../components/tab';
	import {
		fetchUser
	} from '@/assets/js/commonApi';
	import TicketType from './components/ticket-type';
	const defaultFormData = {
		activityId: '',
		performers: [],
		guests: [],
		lineupNature: '',
		isEditStore: 1,
		accountLimitBuyNum: 0,
		sessionIds: [],
		realNameValidType: '',
		realName: '',
		buyType: '',
		commonPerformerDocumentType: [],


		ticketType: '',
		pickupTimes: [],
		pickupAddress: '',
		pickupLongitude: '',
		pickupLatitude: '',
		pickupInstruction: '上门自取时,请提供二维码,手机号,身份证原件(如代领还需代领人身份证原件)',
		mailInstruction: '免邮/采用到付收费',

		isSoldOut: '',
		isHideStartDate: '',
		startTime: '',
		endTime: '',

		entranceType: [],
		seatShowTime: '',
		hotLevel: 0,
		isEditSeatShowTime: '',
		updateTicketPriceNameType: '',
		isAsyncAlterConsignTime:0


	}

	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => null
			}
		},
		components: {
			Tab,
			TicketType
		},
		data() {
			return {
				visible: false,
				dataLoading: false,
				data: null,
				formData: {
					...defaultFormData,
				},
				activityName: '',
				redirect: this.$route.query.redirect,
				guestsList: [],
				artistList: [],
				userLoading: false,
				previewVisible: false,
				sessionVisible: false,
				btypeVisible: false,
				sessionData: null,
				chooseVal1: 0,
				chooseVal2: 0,
				chooseVal3: 0,
				chooseVal4: 1,
				chooseVal5: 0,
				chooseVal6: 0,
				chooseVal7: 0,
				chooseVal8: 0,
				chooseVal9: 0,
				chooseVal10: 0,
				chooseVal11: 0,
				chooseVal12: 0,
				chooseVal13: 0,
				chooseVal14: 0,
				chooseVal15: 0,
				artistType: 1,
				startTime: '',
				endTime: '',
				channelName: '', //5.5.10
				showSeat: '',
				hotLevel: 0
			}
		},
		created() {
			this.getSessions()
		},
		methods: {
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			getSessions() {
				this.formData.sessionIds = []
				this.$request({
						url: "/activity/activitySessions",
						method: "POST",
						params: {
							activityId: parseInt(this.id)
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.sessionData = result
							if (this.sessionData) {
								//this.formData.activityId = this.sessionData.activityId
								this.activityName = this.sessionData.title
								this.channelName = !result.channelName ? 'showstart' : result.channelName.toString()
								this.formData.entranceType = this.channelName && this.channelName == 'showstart' ? [
									1] : []

								const arry = this.sessionData.sessions;
								arry.map(v => {
									this.formData.sessionIds.push(v.id)
								})

							}

						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {

					});
			},
			searchArtist(query) {
				this.searchUser(query, 2, 'artistList');
			},
			searchGuests(query) {
				this.searchUser(query, 2, 'guestsList');
			},
			// 搜索用户
			async searchUser(query, userType, name) {
				if (query !== "") {
					this.userLoading = true;
					const res = await fetchUser({
						queryValue: query,
						userType: userType,
					}).finally(() => {
						this.userLoading = false;
					});
					const {
						state,
						result
					} = res.data;

					if (state == 1 && result) {
						if (name == 'artistList') {
							const arry = [...this.formData.performers];
							result.map(v => {
								if (!arry.find(item => item.id == v.id)) {
									arry.push(v);
								}
							})
							this.artistList = [...arry];
						}
						if (name == 'guestsList') {
							const arry2 = [...this.formData.guests];
							result.map(v => {
								if (!arry2.find(item => item.id == v.id)) {
									arry2.push(v);
								}
							})
							this.guestsList = [...arry2];
						}

					}
				}
			},
			formatTooltip(val) {
				if (val == 0) {
					return "大于1分钟抢光"
				} else if (val != 0 && val <= 3) {
					return "30秒到1分钟内抢光"
				} else if (val >= 4 && val <= 6) {
					return "5秒到30秒抢光"
				} else {
					return "5秒内抢光"
				}
			},
			updateArtistList(data) {

				if (this.artistType === 1) {
					this.artistList.push(data);
					this.formData.performers.push(data);

				} else {
					this.guestsList.push(data);
					this.formData.guests.push(data);
				}
			},
			batchCancel() {

				var _performers = []
				var _guests = []
				if (this.chooseVal1 == 0 && this.chooseVal2 == 0 && this.chooseVal3 == 0 && this.chooseVal4 == 0 && this
					.chooseVal5 == 0 && this.chooseVal6 == 0 && this.chooseVal7 == 0 && this.chooseVal8 == 0 && this
					.chooseVal9 == 0 && this.chooseVal10 == 0 && this.chooseVal11 == 0 && this.chooseVal12 == 0 && this.chooseVal13 == 0 && this.chooseVal14 == 0  && this.chooseVal15 == 0) {
					return this.$message.error("请选择需要批量更新的字段！");
				}
				if (this.chooseVal1 == 1 && this.formData.performers == '') {
					return this.$message.error("艺人不能为空！");
				} else if (this.chooseVal1 == 0 && this.formData.performers && this.formData.performers.length > 0) {
					return this.$message.error("请先勾选艺人阵容！");
				} else {
					if (this.formData.performers && this.formData.performers.length > 0) {
						this.formData.performers.forEach((item, index) => {
							_performers.push(item.id)
						})
					}
				}

				if (this.chooseVal2 == 0 && this.formData.guests && this.formData.guests.length > 0) {
					return this.$message.error("请先勾选嘉宾阵容！");
				} else {
					if (this.formData.guests && this.formData.guests.length > 0) {
						this.formData.guests.forEach((item, index) => {
							_guests.push(item.id)
						})
					}
				}
				if (this.chooseVal3 == 1 && this.formData.lineupNature == '') {
					return this.$message.error("请先选择阵容性质！");
				}
				if (this.chooseVal3 == 0 && this.formData.lineupNature && this.formData.lineupNature != '') {
					return this.$message.error("请先勾选阵容性质！");
				}
				if (this.chooseVal4 == 0 && this.formData.isEditStore == 1) {
					return this.$message.error("请先勾选B类售票权限！");
				}
				if (this.chooseVal5 == 0 && this.formData.accountLimitBuyNum != 0) {
					return this.$message.error("请先勾选场次账号限购！");
				}
				if (this.chooseVal8 == 0 && this.formData.ticketType != '') {
					return this.$message.error("请先勾选票品形态！");
				}

				if (this.chooseVal6 == 0 && (this.formData.buyType != '' || this.formData.commonPerformerDocumentType
						.length != 0)) {
					return this.$message.error("请先勾选票品绑定观演人！");
				}
				if (this.chooseVal6 == 1 && ( this.formData.buyType ==='undefined' || ( this.formData.buyType == 2 ||  this.formData.buyType == 3 ) && this.formData.commonPerformerDocumentType.length === 0 )) {
					return this.$message.error("请先设置票品绑定观演人！");
				}

				if (this.chooseVal7 == 0 && (this.formData.realNameValidType === 0 || this.formData.realNameValidType ===
						1 || this.formData.realNameValidType === 2)) {
					return this.$message.error("请先勾选下单人实名认证！");
				}
				if (this.chooseVal7 == 1 && this.formData.realNameValidType === '') {
					return this.$message.error("请先选择下单人实名认证类型！");
				}

				if (this.chooseVal8 == 1 && !this.formData.ticketStyle) {
					return this.$message.error("请先选择票品形态！");
				}
				if (this.chooseVal8 == 1 && this.formData.ticketStyle == 1 && (this.formData.ticketType == '' || this
						.formData.ticketType == 2 || this.formData.ticketType == 3 || this.formData.ticketType == 4)) {
					return this.$message.error("请先选择电子票类型！");
				}
				if (this.chooseVal8 == 1 && this.formData.ticketStyle == 2 && (this.formData.ticketType == '' || this
						.formData.ticketType == 1 || this.formData.ticketType == 5)) {
					return this.$message.error("请先选择纸质票类型！");
				}

				if (this.chooseVal8 == 1 && this.formData.ticketType == 2 && this.formData.mailInstruction === '') {
					return this.$message.error("请输入说明信息！");
				}
				// if( this.chooseVal9 == 1 && this.formData.isSoldOut === 0 ){
				// 	return this.$message.error("请先勾选强制售罄！");
				// }
				if (this.chooseVal9 == 0 && (this.formData.isSoldOut === 1 || this.formData.isSoldOut === 0) || (this
						.chooseVal9 == 1 && this.formData.isSoldOut === '')) {
					return this.$message.error("请先选择强制售罄选项！");
				}

				if (this.chooseVal14 == 1 && this.startTime == '' && this.endTime == '') {
					return this.$message.error("票品销售时间不能为空！");
				} else if (this.chooseVal14 == 0 && (this.startTime != '' || this.endTime != '')) {
					return this.$message.error("请先勾选票品销售时间！");
				} else if (this.chooseVal14 == 1) {
					if (this.startTime != '') {
						this.formData.startTime = this.startTime;
					}
					if (this.endTime != '') {
						this.formData.endTime = this.endTime;
					}
					if (this.startTime != '' && this.endTime != '' && this.startTime > this.endTime) {
						return this.$message.error("票品销售开始时间不能大于结束时间！");
					}
				}
				if (this.chooseVal10 == 1 && this.formData.isHideStartDate === '') {
					return this.$message.error("请先选择是否展示销售时间！");
				}
				if (this.chooseVal10 == 0 && this.formData.isHideStartDate != '') {
					return this.$message.error("请先勾选选择是否展示销售时间！");
				}
				
				

				if (this.chooseVal12 == 1 && this.showSeat == '') {
					return this.$message.error("请选择场次座位号展示逻辑！");
				}
				if (this.chooseVal12 == 0 && (this.showSeat != '' && this.formData.seatShowTime != '')) {
					return this.$message.error("请先勾选场次座位号展示逻辑！");
				}
				if (this.chooseVal12 == 1 && (this.showSeat == 2 && this.formData.seatShowTime == '')) {
					return this.$message.error("座位号展示逻辑指定时间不能为空！");
				}

				if (this.chooseVal13 == 1 && this.formData.updateTicketPriceNameType == '') {
					return this.$message.error("请选择修改票品名称类型！");
				}
				if (this.chooseVal13 == 0 && this.formData.updateTicketPriceNameType != '') {
					return this.$message.error("请先勾选票品名称批量修改！");
				}

				if (this.chooseVal8 == 1 && (this.formData.ticketType == 3 || this.formData.ticketType == 4) && (this
						.formData.pickupAddress === '' || this.formData.pickupLongitude === '' || this.formData
						.pickupLatitude === '' || this.formData.pickupInstruction === '' || this.formData.pickupTimes &&
						this.formData.pickupTimes.length == 0)) {
					return this.$message.error("请先完善票品形态字段！");
				}
				if (this.formData.sessionIds == '') {
					return this.$message.error("请先选择需要批量更新的场次！");
				}

				if (this.chooseVal1 == 0) {
					delete this.formData.performers;
				}

				if (this.chooseVal3 == 0) {
					delete this.formData.lineupNature;
				}
				if (this.chooseVal4 == 0) {
					delete this.formData.isEditStore;
				}
				if (this.chooseVal5 == 0) {
					delete this.formData.accountLimitBuyNum;
				}
				if (this.chooseVal5 == 0) {
					delete this.formData.accountLimitBuyNum;
				}
				if (this.chooseVal6 == 0) {
					delete this.formData.realName;
					delete this.formData.buyType;
					delete this.formData.commonPerformerDocumentType;
				}
				if (this.chooseVal7 == 0) {
					delete this.formData.realNameValidType;
				}
				if (this.chooseVal8 == 0) {
					delete this.formData.pickupTimes
					delete this.formData.pickupAddress
					delete this.formData.pickupLongitude
					delete this.formData.pickupLatitude
					delete this.formData.pickupInstruction
					delete this.formData.mailInstruction
				}
				if (this.formData.realName === 0) {
					delete this.formData.buyType;
					delete this.formData.commonPerformerDocumentType;
				}
				if (this.chooseVal9 == 0) {
					delete this.formData.isSoldOut;
				}
				if (this.chooseVal10 == 0) {					
					delete this.formData.isHideStartDate;
				}

				if (this.chooseVal12 == 0) {
					delete this.formData.seatShowTime;
				}
				if (this.chooseVal13 == 0) {
					delete this.formData.updateTicketPriceNameType;
				}
				if (this.chooseVal14 == 0) {
					delete this.formData.startTime;
					delete this.formData.endTime;
				}
				if (this.chooseVal15 == 0) {
					delete this.formData.isEditSessionName;
				}
				var _commonPerformerDocumentType = ''
				// if( this.chooseVal6 == 1 && this.formData.realName == 1 && this.formData.commonPerformerDocumentType.length > 0  ){
				// 	_commonPerformerDocumentType = this.formData.commonPerformerDocumentType.toString();
				// }
				if (this.chooseVal6 == 1 && this.formData.commonPerformerDocumentType.length > 0) {
					_commonPerformerDocumentType = this.formData.commonPerformerDocumentType.toString();
				}


				this.formData.performers = _performers
				this.formData.guests = _guests
				this.formData.commonPerformerDocumentType = _commonPerformerDocumentType

				if (this.chooseVal2 == 0) {
					delete this.formData.guests;
				}


				if (this.chooseVal6 == 1) {
					if (this.formData.buyType == 0) {
						this.formData.realName = 0
					} else {
						this.formData.realName = 1
					}
				} else {
					this.formData.realName = ''
					this.formData.buyType = ''
				}

				var _entranceType = '';
				var _electronicType = ''
				if (this.chooseVal8 == 1) {
					_entranceType = this.formData.entranceType.toString();
					_electronicType = this.formData.ticketType === 5 && this.formData.ticketStyle == 1 ? 2 : this.formData
						.ticketStyle == 2 ? '' : 1
				} else {
					_entranceType = ''
					_electronicType = ''
				}


				if (this.hotLevel == 2) {
					this.formData.hotLevel = 4
				} else if (this.hotLevel == 3) {
					this.formData.hotLevel = 7
				} else {
					this.formData.hotLevel = this.hotLevel
				}

				if (this.chooseVal11 != 1) {
					delete this.formData.hotLevel;
				}

				this.$confirm('是否确认批量更新？', '批量更新', {
					type: 'warning',
					center: true,
					closeOnClickModal: false
				}).then(() => {
					this.dataLoading = true
					this.$request({
						url: '/activity/batchUpdateSessions',
						method: 'POST',
						data: {
							...this.formData,
							activityId: parseInt(this.id),
							entranceType: _entranceType, //electronicType （电子票类型(ticketType为1时才有用) 1：二维码电子票 2：身份证电子票
							electronicType: _electronicType, //
							ticketType: this.formData.ticketType === 5 ? 1 : this.formData.ticketType,
							seatShowTime: this.showSeat == 2 ? this.formData.seatShowTime : '',
							isEditSeatShowTime: this.chooseVal12 == 1 ? 1 : '',
							isEditSessionName: this.chooseVal15 == 1 ? 1 :0
						},
					}).then(res => {
						let {
							state,
							msg
						} = res.data;
						if (state == 1) {
							this.$message.success("操作成功");
							this.getSessions();
							this.goBack();
							this.dataLoading = false
						} else {
							this.$message.error(msg || "请求失败");
							this.chooseVal1 = 0;
							this.chooseVal2 = 0;
							this.chooseVal3 = 0;
							this.chooseVal4 = 1;
							this.chooseVal5 = 0;
							this.chooseVal6 = 0;
							this.chooseVal7 = 0;
							this.chooseVal8 = 0;
							this.chooseVal9 = 0;
							this.chooseVal10 = 0;
							this.chooseVal11 = 0;
							this.chooseVal12 = 0;
							this.chooseVal13 = 0;
							this.chooseVal14 = 0;
							this.chooseVal15 = 0;
							this.formData = {
								...defaultFormData
							}
							this.dataLoading = false

						}
					}).catch(() => {
						this.$message.error("操作失败");
					})
				}).catch(() => {
					this.chooseVal1 = 0;
					this.chooseVal2 = 0;
					this.chooseVal3 = 0;
					this.chooseVal4 = 1;
					this.chooseVal5 = 0;
					this.chooseVal6 = 0;
					this.chooseVal7 = 0;
					this.chooseVal8 = 0;
					this.chooseVal9 = 0;
					this.chooseVal10 = 0;
					this.chooseVal11 = 0;
					this.chooseVal12 = 0;
					this.chooseVal13 = 0;
					this.chooseVal14 = 0;
					this.chooseVal15 = 0;
					this.formData = {
						...defaultFormData
					}
					this.dataLoading = false

				})

			}
		}
	}
</script>
<style lang="scss" scoped>
	.info-table td {
		border-right: 1px solid #eee;

		&.right {
			padding: 20px
		}
	}

	.hand {
		cursor: pointer;
	}
</style>